// app/store.js
import { configureStore } from '@reduxjs/toolkit'
import authReducer from './auth/AuthSlice'
import yearReducer from './tournament/YearSlice'
import { AuthApi } from './auth/AuthApi';
import { setupListeners } from '@reduxjs/toolkit/query';
import { TournamentApi } from './tournament/TournamentApi';
import { ClubApi } from './club/ClubApi';
import { TeamApi } from './team/TeamApi';
import { EmailApi } from './email/EmailApi';
import { UserApi } from './user/UserApi'


const RootStore = configureStore({
  reducer: {
    // Hinzufügen der generierten Reducer aus dem ReduxQuery.
    [AuthApi.reducerPath]: AuthApi.reducer, 
    [TournamentApi.reducerPath]: TournamentApi.reducer,
    [ClubApi.reducerPath]: ClubApi.reducer,
    [TeamApi.reducerPath]: TeamApi.reducer,
    [EmailApi.reducerPath]: EmailApi.reducer,
    [UserApi.reducerPath]: UserApi.reducer,
    // Ebenfalls für die Authentifizierung benötigen
    // wir die Möglichkeit, auf den aktuellen Status
    // zugreifen zu können, ohne jedes Mal eine erneute
    // Authentifizierung anzustoßen
    auth: authReducer,
    year: yearReducer,
  },

  // Die RTK Query API Middleware hinzufügen
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([ 
      AuthApi.middleware, 
      TournamentApi.middleware,
      ClubApi.middleware,
      TeamApi.middleware,
      EmailApi.middleware,
      UserApi.middleware,
    ]),
});

setupListeners(RootStore.dispatch);

export default RootStore;

